export default __webpack_public_path__ + "static/media/si1.ad0603cc.jpg";